const _clientConfig = [];
_clientConfig['prd'] = {
  'client_id': '1haan93k1rl96u3ghkdrh2eab6',
  'identity_pool_id': 'us-east-1:2a322810-dcc5-49b6-a700-d1c56500a9d5',
  'region': 'us-east-1',
  'user_pool_id': 'us-east-1_qFqlOE6Vg',
  'api_url': 'https://1o7aqg98nk.execute-api.us-east-1.amazonaws.com/prd',
  's3_region': 'us-east-1',
  'bucket': 'otaglobal-ota-files-prd-us-east-1-bucket'
};
const clientConfig = _clientConfig[process.env.REACT_APP_PUBLISH_ENV];
export default clientConfig;
